import type {TMajorActionBirthdayData} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import {BirthdayCard} from '~/models/game/Cards/ActionCard'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import MajorAction from '~/models/game/MajorAction'
import {inTense} from '~/utils/language'

export default class MajorActionBirthday extends MajorAction<TMajorActionBirthdayData> {
  card: BirthdayCard

  constructor(data: TMajorActionBirthdayData) {
    super(data)
    this.card = new BirthdayCard(data.card)
  }

  public userFacingDescription({
    tense,
    skin,
    gamePosition,
  }: TMajorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const majorActor = gamePosition.majorActorPlayer

    return skins[skin].gameLogDescriptions.majorActions.birthday({
      tense,
      actor:
        tense === 'past'
          ? majorActor.id === currentPlayer?.id
            ? 'You'
            : majorActor.username
          : undefined,
      playVerb: inTense(tense)(tense === 'past' ? 'play' : 'Play'),
      cardName: this.card.displayName(skin),
    })
  }
}
